<div class="categoryTreeV2">
  <div *ngFor="let item of list" class="rowCat">
    <div class="line"></div>
    <div class="cat">
      <div class="label">

        <span *ngIf="getStatus(item) === 'ACTIVE'" class="badge-active">
          <p>ACTIVA</p>
        </span>
        <span *ngIf="getStatus(item) === 'INACTIVE'" class="badge-inactive">
          <p>INACTIVA</p>
        </span>

        <span (click)="getSubs(item)">
          {{ getName(item) }}
        </span>

        <div class="actions">
          <div class="list_opcion">
            <i *ngIf="level < 3" class="fa fa-plus-square-o" 
               (click)="addCategory(item); $event.stopPropagation()" title="+ Categoría">
            </i>
            <i class="fa fa-pencil-square-o" 
               (click)="editCategory(item); $event.stopPropagation()" title="Editar Categoría">
            </i>
            <i class="fa fa-trash-o" 
               (click)="deleteCategory(item); $event.stopPropagation()" title="Borrar Categoría">
            </i>
            <i class="fa fa-plus-circle" 
               (click)="viewSpecs(item.id); $event.stopPropagation()" title="Ver Especificaciones">
            </i>
          </div>
        </div>
      </div>

      <ng-container *ngIf="expandedMap[item.id] && level < 3">
        <app-category-tree-v2
          [list]="childrenMap[item.id]"
          [level]="level + 1"
          (addCategoryEvent)="addCategory($event)"
          (editCategoryEvent)="editCategory($event)"
          (deleteCategoryEvent)="deleteCategory($event)">
        </app-category-tree-v2>
      </ng-container>

    </div>
  </div>
</div>

